import { gql } from "@apollo/client";

export const CLAIM_ORGANISATION_USER = gql`
  mutation claimWithUser($user_id: ID!, $organization_id: ID!) {
    claimWithUser(user_id: $user_id, organization_id: $organization_id) {
      claim {
        id
        organization {
          id
          name
        }
        status
      }
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization($input: InputOrganization!) {
    createOrganization(input: $input) {
      organization {
        id
        name
        description
        operating_status
      }
    }
  }
`;

export const FETCH_INVESTORS_BY_PREFERENCES = gql`
  query ($aggs: AggregationRequest!) {
    aggregate(aggregations: $aggs) {
      aggregations
      took
    }
  }
`;
